import {
  convertMachToMPH,
  convertMachToKnots,
  convertMachToKPH
} from "./MachConversion";
import {
  convertMPHToMach,
  convertMPHToKnots,
  convertMPHToKPH
} from "./MPHConversion";
import {
  convertKnotsToMach,
  convertKnotsToMPH,
  convertKnotsToKPH
} from "./KnotsConversion";
import {
  convertKPHToMach,
  convertKPHToMPH,
  convertKPHToKnots
} from "./KPHConversion";

function getFinalMachConversion(val, conType) {
  let result = "";
  if (conType === "matomp") {
    result = convertMachToMPH(parseFloat(val));
  } else if (conType === "matokn") {
    result = convertMachToKnots(parseFloat(val));
  } else if (conType === "matokp") {
    result = convertMachToKPH(parseFloat(val));
  }
  return result;
}

function getFinalMPHConversion(val, conType) {
  let result = "";
  if (conType === "mptoma") {
    result = convertMPHToMach(parseFloat(val));
  } else if (conType === "mptokn") {
    result = convertMPHToKnots(parseFloat(val));
  } else if (conType === "mptokp") {
    result = convertMPHToKPH(parseFloat(val));
  }
  return result;
}

function getFinalKnotsConversion(val, conType) {
  let result = "";
  if (conType === "kntoma") {
    result = convertKnotsToMach(parseFloat(val));
  } else if (conType === "kntomp") {
    result = convertKnotsToMPH(parseFloat(val));
  } else if (conType === "kntokp") {
    result = convertKnotsToKPH(parseFloat(val));
  }
  return result;
}

function getFinalKPHConversion(val, conType) {
  let result = "";
  if (conType === "kptoma") {
    result = convertKPHToMach(parseFloat(val));
  } else if (conType === "kptomp") {
    result = convertKPHToMPH(parseFloat(val));
  } else if (conType === "kptokn") {
    result = convertKPHToKnots(parseFloat(val));
  }

  return result;
}

export {
  getFinalMachConversion,
  getFinalMPHConversion,
  getFinalKnotsConversion,
  getFinalKPHConversion
};
